import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { trapFocus } from "../../helpers";
import style from "./styles";
import CloseSVG from "../../assets/closeButton.svg";
import premierIcon from "../../assets/asos-premier-1.png";

const TermsAndConditionsModal = ({
  isVisible,
  closeModal,
  termsUrl,
  countryData,
}) => {
  const modalRef = useRef();
  const closeModalRef = useRef();
  const iframeRef = useRef();
  const escapeModal = (e) => e.key === "Escape" && closeModal();

  useEffect(() => {
    if (closeModalRef.current) {
      closeModalRef.current.focus();
    }
    if (iframeRef.current) {
      iframeRef.current.contentWindow.addEventListener("keydown", (e) =>
        escapeModal(e)
      );
    }
    if (modalRef.current) {
      trapFocus(modalRef.current);
    }
  });

  return isVisible && countryData ? (
    <div
      className="PremierTermsAndConditionsContainer"
      ref={modalRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="terms-title"
      onKeyDown={(e) => escapeModal(e)}
    >
      <div
        className={style.PremierTermsAndConditionsOverlay}
        onClick={() => closeModal()}
      ></div>
      <div className={style.TermsAndConditions}>
        <div className={style.TermsAndConditionsTitle}>
          <img
            className={style.PremierIcon}
            src={premierIcon}
            alt="ASOS Premier"
          />
          <button
            ref={closeModalRef}
            className={style.close}
            aria-label="Close terms modal (ESC)"
            onClick={() => closeModal()}
            autoFocus={true}
          >
            <CloseSVG alt="Close (ESC)" />
          </button>
        </div>
        <div className={style.TermsAndConditionsContent}>
          <iframe
            ref={iframeRef}
            onKeyDown={(e) => escapeModal(e)}
            name="terms"
            src={termsUrl}
          />
        </div>
      </div>
    </div>
  ) : null;
};

TermsAndConditionsModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  termsUrl: PropTypes.string,
  countryData: PropTypes.object,
};

export default TermsAndConditionsModal;
